<template>
	<div id="privacy-component">
		<LandingHeaderBar class="white-header full-width-header"/>	
		<div class="inner-main">
			<LandingPrivacy />
		</div>
	</div>
</template>

<script>

import LandingPrivacy from './landing-privacy/Landing-Privacy.vue'
import LandingHeaderBar from '../shared-views/landing-header-bar/Landing-Header-Bar.vue'


export default {
	name: 'LandingPrivacyComponent',

	components: {
		LandingPrivacy,
		LandingHeaderBar,
	}
}

</script>

<style scoped>
</style>